/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";
import YearEndBoard from "./YearEndBoard";

const YearEndList = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'EXPENSE')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "EXPENSE")
      }
    }
  }, [permissions])

  return (
    !isEmpty(targetPermission) && (
      <div className="yaer-end-list">
        <PageHeader title={"연말 정산 내역"} />
        <YearEndBoard ownership={'all'} />
      </div>
    ));
};

export default YearEndList;
